import { DownloadIcon } from '@chakra-ui/icons';
import { Box, Center, Flex, Link } from '@chakra-ui/react';

export interface DocumentListItemProps {
    title: string;
    downloadLink: string;
};

const DocumentListItem = (props: DocumentListItemProps) => {
    return (
        <Box
            as={ Link }
            bg='brand.grey' 
            display='flex' 
            flex='1'
            padding='10px 20px 10px 20px' 
            color='brand.black'
            href={ props.downloadLink }
            _hover={{ bg: 'brand.darkGrey' }}
            isExternal
        >
            <Flex flex='1'>
                { props.title }
            </Flex>
            <Flex>
                <Center>
                    <DownloadIcon />
                </Center>
            </Flex>
        </Box>
    );
};

export default DocumentListItem;